export var Display;
(function (Display) {
    Display[Display["Standard"] = 0] = "Standard";
    Display[Display["Immersive"] = 1] = "Immersive";
    Display[Display["Showcase"] = 2] = "Showcase";
})(Display || (Display = {}));
